import { AfterViewInit, Directive, ElementRef, NgZone, OnDestroy } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { AnimationService } from '../shared/services/animation.service';

@Directive({
  selector: '[appAnimateOnScroll]',
  standalone: true
})
export class AnimateOnScrollDirective implements AfterViewInit, OnDestroy {
  private subscription?: Subscription;
  private mutationObserver?: MutationObserver;
  private readonly isBrowser: boolean;

  constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly animation: AnimationService,
    private readonly router: Router,
    private readonly zone: NgZone,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngAfterViewInit(): void {
    if (!this.isBrowser) {
      return;
    }

    this.bindCurrentView();

    this.subscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        window.requestAnimationFrame(() => this.bindCurrentView());
      });

    if (typeof MutationObserver !== 'undefined') {
      this.zone.runOutsideAngular(() => {
        this.mutationObserver = new MutationObserver(() => {
          window.requestAnimationFrame(() => this.animation.refresh());
        });

        this.mutationObserver.observe(this.elementRef.nativeElement, {
          childList: true,
          subtree: true
        });
      });
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.mutationObserver?.disconnect();
    this.animation.destroy();
  }

  private bindCurrentView(): void {
    this.animation.initPageMotion(this.elementRef.nativeElement);
  }
}
